import React, { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import './styles.scss';
import ApiService from 'app/lib/services/ApiService';
import NotificationService from 'app/lib/services/NotificationService';
import RightArrow from 'static/icons/account/right-arrow.svg';
import DownArrow from 'static/icons/arrow-down-blue.svg';
import EventService from 'services/EventService';
import AppEvents from 'app/lib/AppEvents';

const { Panel } = Collapse;

const AccountMenu = (props) => {
    const [activeAccount, setActiveAccount] = useState(null)
    const [accounts, setAccounts] = useState([])

    useEffect(() => {
        const user = props.auth.user;
        if (user) {
            if (user.roles.indexOf('admin') > -1) {
                ApiService.get('/admin/users/activeAccounts')
                    .then(res => {
                        setAccounts(res.accounts)
                        setActiveAccount(user.activeAccount)
                    })
                    .catch((error) => {
                        console.log('fetching all active accounts error - ', error);
                        NotificationService.notifyError('Error', 'Failed fetching all active accounts');
                    })
            } else {
                setAccounts(user.accounts || [])
                setActiveAccount(user.activeAccount)
            }
        }
    }, [props.auth.user]);

    const changeAccount = async (toAccount) => {
        EventService.dispatch(AppEvents.CHANGE_ACCOUNT, toAccount);
    }

    if (!activeAccount || accounts.length === 0) {
        return null
    }

    if (accounts.length === 1) {
        const domain = (activeAccount.storeInfo && activeAccount.storeInfo.domain) || 'solene.co';
        return (
            <div className="account-menu">
                <div className="account-display brand-account">
                    <span className="brand-logo">{(activeAccount.name || 'S').trim().charAt(0)}</span>
                    <span className="brand-meta">
                        <b>{activeAccount.name}</b>
                        <em>{domain}</em>
                    </span>
                </div>
            </div>
        )
    }

    return (
        <div className="account-menu">
            <Collapse
                className="account-collapse"
                expandIcon={({ isActive }) => <img src={isActive ? DownArrow : RightArrow} />}
            >
                <Panel header={
                    <div className="account-menu-header">
                        {activeAccount.name}
                    </div>
                }>
                    <div className="accounts">
                        {accounts.map(account => (
                            <div className="account-menu-item" key={account['_id']} onClick={() => changeAccount(account)}>
                                {account.name}
                            </div>
                        ))}
                    </div>
                </Panel>
            </Collapse>
        </div>
    )
};

export default AccountMenu;
